import React, { Component } from "react";
import ProductSelectors from "./SizeSelectorApp/product-selectors";
import ProductList from "./SizeSelectorApp/product-list";
import ProductCards from "./SizeSelectorApp/product-cards";
import Pagination from "./SizeSelectorApp/pagination";
import axios from "axios";

class SizeSelectorApp extends Component {
  constructor() {
    super();

    this.state = {
      productList: [],
      searchTerm: "",
      filtered: [],
      viewType: "list",
      showImg: false,
      activePage: 1,
      nrPerPage: 12
    };

    axios
      .get(process.env.PUBLIC_URL + "/data.csv")
      .then(response => {
        let json = this.csvTojson(response.data);
        console.log(json);
        this.setState({
          productList: json.filter(({ Type }) => Type.length > 0)
        });
      })
      .catch(function(error) {
        console.log(error);
      });

    //this.generateResults = this.generateResults.bind(this);
  }

  filterSearch = event => {
    this.setState({ searchTerm: event.target.value, activePage: 1 });
  };

  csvTojson(csv) {
    const lines = csv.split("\n");
    let result = [];
    const headers = lines[0].split(";");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(";");
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }
      result.push(obj);
    }
    return result;
  }

  searchBoxFilter = () => {
    const { searchTerm, filtered } = this.state;
    return filtered.filter(obj => {
      if (searchTerm.length === 0) return true;

      for (let key in obj) {
        try {
          if (obj[key].match(new RegExp(searchTerm, "i"))) return true;
        } catch (err) {
          console.log(searchTerm, "has illegal regex characters in it.");
        }
      }
      return false;
    });
  };
  handlePaginationChange = value => {
    this.setState({ activePage: Number(value) });
  };

  render() {
    let filtered = this.searchBoxFilter();

    const { nrPerPage, activePage } = this.state;

    const indexOfLast = activePage * nrPerPage;
    const indexOfFirst = indexOfLast - nrPerPage;
    const InView = filtered.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filtered.length / nrPerPage);

    return (
      <div className="ui container">
        <ProductSelectors
          productList={this.state.productList}
          filteredCount={this.state.filtered.length}
          handleResult={filtered => {
            this.setState({ filtered, activePage: 1, searchTerm: "" });
          }}
          filterSearch={this.filterSearch}
          handleShowResultClick={verdict => {
            this.setState({ showResult: true });
          }}
        />
        <div className="ui menu">
          <div className="ui category search item">
            <div className="ui transparent icon input">
              <input
                className="searchBox"
                type="text"
                onChange={this.filterSearch}
                placeholder="Search..."
              />
              <i className="search link icon" />
            </div>
          </div>
          <div className="ui category item searchResult">
            Visar {filtered.length} av totalt {this.state.filtered.length}.
          </div>
          <div className="right menu">
            <div className="ui icon buttons">
              <button
                className={`ui button ${
                  this.state.showImg === true ? "active" : ""
                }`}
                onClick={() => this.setState({ showImg: !this.state.showImg })}
              >
                <i className="image outline center icon" />
              </button>
              <button
                className={`ui button ${
                  this.state.viewType === "list" ? "active" : ""
                }`}
                onClick={() => this.setState({ viewType: "list" })}
              >
                <i className="th list center icon" />
              </button>
              <button
                className={`ui button ${
                  this.state.viewType === "cards" ? "active" : ""
                }`}
                onClick={() => this.setState({ viewType: "cards" })}
              >
                <i className="th icon" />
              </button>
            </div>
          </div>
        </div>
        <div className="product-list-container">
          {this.state.viewType === "list" ? (
            <ProductList products={InView} showImg={this.state.showImg} />
          ) : (
            <ProductCards products={InView} showImg={this.state.showImg} />
          )}
        </div>
        <br />
        <Pagination
          activePage={this.state.activePage}
          totalPages={totalPages}
          onPageChange={this.handlePaginationChange}
        />
        <br /> <br /> <br /> <br /> <br />
      </div>
    );
  }
}

export default SizeSelectorApp;
